<template>
  <el-dialog custom-class="schedule_dialog"
             :width="dw"
             :top="dt"
             :visible.sync="isShow"
             title=""
             :close-on-click-modal="false"
             center>
    <div class="imgWrap">
      <img class="schedule_img"
           :src="imgSrc"
           @error="imgErr"
           alt="">
    </div>
    <div class="btn">
      <a class="download"
         :href="imgSrc"
         download="">下载</a>
    </div>
  </el-dialog>
</template>

<script>
  import class_d from "@/assets/images/timetable/class_d.png";
  import class_c from "@/assets/images/timetable/class_c.jpg";
  import class_a from "@/assets/images/timetable/class_a.jpg";
  import class_b from "@/assets/images/timetable/class_b.png";
  import class_education from "@/assets/images/timetable/class_education.jpg";

  export default {
    name: "Schedule",
    props: {
      flag: {
        type: Boolean,
        required: true
      },
      level: {
        type: String,
        required: true,
        default: "D"
      },
      class_train_type: {
        type: String,
        required: true,
        default: "train"
      },
      pic: {
        required: true
      },
      dw: {
        type: String,
        required: false,
        default: "830px"
      },
      dt: {
        type: String,
        required: false,
        default: "7vh"
      },
    },
    data() {
      return {
        HOSTURL: process.env.VUE_APP_URL,
        class_d,
        class_c,
        class_b,
        class_a,
        class_education
      }
    },
    computed: {
      isShow: {
        set(bool) {
          this.$emit("hide", bool);
        },
        get() {
          return this.flag;
        },
      },
      imgSrc: {
        get() {
          let src;
          if (this.pic && this.pic !== this.class_d) {
            src = this.HOSTURL + this.pic;
          }else{
            if(this.class_train_type === 'train'){
              switch (this.level) {
                case "A" : src=this.class_a;break;
                case "C" : src=this.class_c;break;
                case "B" : src=this.class_b;break;
                case "D" : src=this.class_d;break;
              }
            }else{
              src=this.class_education;
            }
          }
          return src;
        },
      }
    },
    methods: {
      imgErr() {
        if(this.class_train_type === 'train'){
          switch (this.level) {
            case "A" :
              this.$emit("update:pic",  this.class_a);
              break;
            case "C" :
              this.$emit("update:pic",  this.class_c);
              break;
            case "B" :
              this.$emit("update:pic",  this.class_b);
              break;
            case "D" :
              this.$emit("update:pic",  this.class_d);
              break;
          }
        }else {
          this.$emit("update:pic",  this.class_education);
        }
        
      },
    }
  }
</script>

<style lang="stylus">
  .schedule_dialog {
    @import '~@/assets/css/variable';
    /*max-width: 750px;*/
    .el-dialog__header {
      padding: 20px 0 0;
      .el-dialog__title {
        font-size: 20px;
      }
    }
    .imgWrap {
      text-align: center;
      .schedule_img {
        max-width: 100%;
      }
    }
    .btn {
      margin: 20px auto 0;
      .download {
        display: block;
        width: 150px;
        height: 40px;
        margin: 0 auto;
        color: $color_white;
        font-size: $font_size_big;
        text-align: center;
        line-height: 40px;
        background-color: $color_err;
        user-select: none;
      }
    }
  }
</style>
